import { render, staticRenderFns } from "./lawDetail.vue?vue&type=template&id=b0959950&scoped=true"
import script from "./lawDetail.vue?vue&type=script&lang=js"
export * from "./lawDetail.vue?vue&type=script&lang=js"
import style0 from "./lawDetail.vue?vue&type=style&index=0&id=b0959950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0959950",
  null
  
)

export default component.exports